import { FC } from 'react';
import { useEffect, useState } from 'react';
import { useDP3Store } from '@elem/compPage/DP3/DP3Provider';
import EfImg from 'elem/ui/ef-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper';
import EfSwiperLevel2 from '@elem/ui/ef-swiper-level2';
import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3');
    const { pageStatus } = useDP3Store();
    const [isPC, setIsPC] = useState(true);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsPC(window.innerWidth > 1024);
        }
    }, []);

    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726795587950/d.jpg',
            subtitle: 'Easy, plug-and-play setup',
            desc: "Take it out of the box, find a spot, and plug it in. That's it. No installation, no home tweaks.",
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718769266107/a1.jpg',
            subtitle: "It's child's play",
            desc: 'So simple, even a kid can manage it. Skip the noisy generators refueling and tangled cords, with no complex setup or manual starts required, ensuring you have power when you need it most.',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726731585248/app.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1727579091814/au-sc6.jpg',
            subtitle: 'Power. With just one tap.',
            desc: 'Stay connected to your home energy with the EcoFlow app, anywhere, anytime. Control and monitor your power seamlessly, even remotely during outages.',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718768869115/c1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1727579092075/au-sc5.jpg',
            subtitle: 'Portable design for ideal lifestyle',
            desc: 'Boosts portability with its wide wheels, ergonomic handle, and compact design. Its magnetic sliding doors simplify access, optimizing space and power for mobility without compromise. Ideal for dynamic lifestyles and maximizing family space.',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719055675644/bb2.jpeg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719037036923/c3%20(1).jpg',
            subtitle: 'Zero maintenance',
            desc: 'Offers cutting-edge engineering and battery technology to guarantee a longer product life and a maintenance-free journey. No replacements, no hassle—just reliable power. ',
        },
    ];

    if (pageStatus !== IPageStatus.statusA)
        return (
            <div id="dp3-teaser-E" className={`${css.thecomp}`}>
                <p className="title swiper">Effortless Power for Every Family Member</p>
                <EfSwiperLevel2 list={list} />
            </div>
        );

    return (
        <div className={`${css.thecomp} GtmModuleData-section`} data-section-id={'dp3-E'} data-section-title={'Effortless Power for Every Family Member'}>
            <p className="title">Effortless Power for Every Family Member</p>
            {isPC ? (
                <div className="box">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726666868486/6.jpg" />
                    <div className="info">
                        <div className="l">Easy, plug-and-play setup</div>
                        <div className="r">
                            <p className="desc">
                                - Fully manage home power from anywhere with an app
                                <br />- Effortless portability and space-efficient
                            </p>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="box">
                    <Swiper
                        className="swiper-box"
                        modules={[Pagination, Autoplay]}
                        spaceBetween={0}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        loop={true}
                        pagination={{ clickable: true }}
                        // autoplay={{
                        //     delay: 4250,
                        //     disableOnInteraction: false,
                        // }}
                    >
                        <SwiperSlide className={`swiper-item`}>
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726717031578/1-3-tuya.jpg" />
                        </SwiperSlide>
                        <SwiperSlide className={`swiper-item`}>
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726716763458/1-3-1-tuya.jpg" />
                        </SwiperSlide>
                        <SwiperSlide className={`swiper-item`}>
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726716762467/1-3-2-tuya.jpg" />
                        </SwiperSlide>
                    </Swiper>
                    <div className="info">
                        <p className="l">Easy, plug-and-play setup</p>
                        <div className="r">
                            <p className="desc">
                                - Fully manage home power from anywhere with an app
                                <br />- Effortless portability and space-efficient
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TheComp;
